import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppNewInput } from "../../../../shared/components/AppNewInput";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { useEffect, useState } from "react";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { DialogProps } from "@mui/material";
import { isLatinAndStandardChars } from "../../../../shared/utils/isLatinAndStandardChars";
import styles from "./styles.module.css";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";

interface Props extends Omit<DialogProps, "open"> {
  subtype: string;
  handleCreateAgent: (objectName: string, agentName: string) => void;
  closeModal: (id: TModalsIds, subtype: string) => void;
}

export const CreateAgentModal = ({
  subtype,
  closeModal,
  handleCreateAgent,
}: Props) => {
  const createAgent = useModalSelectors("create_agent_modal");
  const [agentName, setAgentName] = useState<string>("");
  const { t } = useTranslation();
  const [objectName, setObjectName] = useState<string>(t("agents.agent"));
  const [isError, setIsError] = useState<boolean>(false);
  useEffect(() => {
    setIsError(false);
  }, [createAgent.isOpen]);

  const handleCloseModal = () => {
    closeModal("create_agent_modal", "");
  };

  const handleChangeNames = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    type: "object" | "agent",
  ) => {
    if (type === "object") {
      setObjectName(event.target.value);
    } else if (type === "agent") {
      const newValue = event.target.value.toLowerCase();
      if (!isLatinAndStandardChars(newValue)) {
        setIsError(true);
        return;
      }

      if (isError) setIsError(false);

      setAgentName(newValue);
    }
  };

  return (
    <ModalBasic
      open={createAgent.isOpen && createAgent.subtype === subtype}
      title={"Создание агента"}
      hasCloseButton
      closeModal={handleCloseModal}
      onClose={handleCloseModal}
      hasFooter
      buttonOkText={t("common.confirm_button")}
      onOk={() => {
        handleCreateAgent(objectName, agentName);
        closeModal("create_agent_modal", subtype);
      }}
      onCancel={handleCloseModal}
      disabledOkBtn={objectName === "" || agentName === ""}
      className={styles["modal"]}
    >
      <div className={styles.container}>
        <div className={styles["input-container"]}>
          <AppLabel>Имя объекта</AppLabel>
          <AppNewInput
            value={objectName}
            className={styles.input}
            placeholder={
              "Введите имя для объекта, которое будет отображаться в сайдбаре"
            }
            onChange={(e) => handleChangeNames(e, "object")}
          />
        </div>
        <div className={styles["input-container"]}>
          <AppLabel>Имя Агента</AppLabel>
          <AppNewInput
            value={agentName}
            className={classNames(isError && styles["input-error"])}
            placeholder={"Пример: my-agent-01"}
            onChange={(e) => handleChangeNames(e, "agent")}
          />
          <span
            className={classNames(
              styles.error,
              isError && styles["with-error"],
            )}
          >
            {t("editor.change_name_validation_error")}
          </span>
        </div>
      </div>
    </ModalBasic>
  );
};
